<template>
  <el-tooltip :effect="effect" :content="content" :placement="placement" v-if="isShowTip">
    <span :class="{ className, text: true }">{{ formatText }}</span>
  </el-tooltip>
  <span v-else :class="{ className, text: true }">{{ formatText }}</span>
</template>

<script>
import { truncateString } from '@/utils/utils'

export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    keepLength: {
      type: Number,
      default: 8
    },
    className: {
      type: String
    },
    style: Object,
    placement: {
      type: String,
      default: 'top-start'
    },
    effect: {
      type: String,
      default: 'dark'
    }
  },
  computed: {
    formatText() {
      return /^[\u2E80-\uFE4F·]+$/.test(this.content)
        ? truncateString(this.content, this.keepLength)
        : this.content
    },
    isShowTip() {
      return this.content.length > this.keepLength
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.text {
  font-size: 14px;
}
</style>
